module.exports = __webpack_public_path__ + "static/media/watchHistory.6922633e.svg";